class CartRecommendations extends HTMLElement {

	constructor(){
		super();
		this._refreshTimeout = null;
		this._boundCartForm = null;
		this._onCartUpdated = this.scheduleRecommendationsRefresh.bind(this);
		this.bindCartFormListener();
		this.bindAddToCartListeners();
		this.generateRecommendations();
	}

	bindCartFormListener(){
		const cartForm = document.getElementById('AjaxCartForm');
		if ( ! cartForm || this._boundCartForm === cartForm ) {
			return;
		}

		if ( this._boundCartForm ) {
			this._boundCartForm.removeEventListener('cart-updated', this._onCartUpdated);
		}

		this._boundCartForm = cartForm;
		this._boundCartForm.addEventListener('cart-updated', this._onCartUpdated);
	}

	bindAddToCartListeners(){
		this.querySelectorAll('product-form[data-ajax-cart]').forEach(form=>{
			if ( form.hasAttribute('data-recommendations-refresh-bound') ) {
				return;
			}
			form.setAttribute('data-recommendations-refresh-bound', '');
			form.addEventListener('add-to-cart', ()=>{
				this.scheduleRecommendationsRefresh();
			});
		});
	}

	scheduleRecommendationsRefresh(){
		if ( this._refreshTimeout ) {
			clearTimeout(this._refreshTimeout);
		}
		this._refreshTimeout = setTimeout(()=>{
			this.generateRecommendations();
		}, 100);
	}

	generateRecommendations(){
		this.bindCartFormListener();
		const cartForm = document.getElementById('AjaxCartForm');
		if ( ! cartForm ) {
			return;
		}

		const cartItems = cartForm.querySelectorAll('[data-js-cart-item]');
		if ( cartItems.length > 0 ) {
			fetch(`${KROWN.settings.routes.product_recommendations_url}?section_id=${this.dataset.section}&product_id=${cartItems[0].dataset.productId}&limit=${this.dataset.limit}`)
				.then(response => response.text())
				.then(text => {
					const innerHTML = new DOMParser()
            .parseFromString(text, 'text/html')
            .querySelector('[data-js-cart-recommendations-performed]');
	          if ( innerHTML && innerHTML.querySelectorAll('[data-js-product-item]').length > 0 ) {
	          	this.innerHTML = innerHTML.innerHTML;
	          } else {
	          	this.innerHTML = '';
	          }
					this.bindAddToCartListeners();
				})
				.catch(() => {
					this.bindAddToCartListeners();
				})
		} else {
			this.innerHTML = '';
		}
	}
}
customElements.define('cart-recommendations', CartRecommendations);